export const staticTextLookup = {
  county: '', // empty string to be ignored when displayed
  countyPlaceholder: '', // empty string to be ignored when displayed
  impressum: 'Impressum',
}